import { useEffect, useState } from 'react';
import { procApi } from '../../api/procurement.js';
import { useAuth } from '../../contexts/AuthContext.jsx';

export default function Warehouses() {
  const { can } = useAuth();
  const [items, setItems] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const canCreate = can('warehouse', 'create');

  function refresh() { procApi.warehouses().then((d) => setItems(d?.items || [])); }
  useEffect(refresh, []);

  async function submit(e) {
    e.preventDefault();
    const fd = new FormData(e.currentTarget);
    await procApi.createWarehouse({
      name: fd.get('name'),
      code: fd.get('code') || null,
      location: fd.get('location') || null,
    });
    e.currentTarget.reset();
    setShowForm(false);
    refresh();
  }

  return (
    <section>
      <header className="page-header">
        <h1>Warehouses</h1>
        {canCreate && <button className="btn primary" onClick={() => setShowForm((s) => !s)}>{showForm ? 'Close' : '+ New Warehouse'}</button>}
      </header>
      {showForm && (
        <form onSubmit={submit} className="card form-card grid-form">
          <label>Name<input name="name" required /></label>
          <label>Code<input name="code" placeholder="e.g. WH-01" /></label>
          <label className="full">Location<input name="location" /></label>
          <div className="full actions"><button className="btn primary" type="submit">Create</button></div>
        </form>
      )}
      <div className="card-grid">
        {items.map((w) => (
          <div key={w.id} className="card">
            <h3>{w.name}</h3>
            <p className="muted">{w.code || '—'} · {w.location || 'No location set'}</p>
            <p className="muted small">Manager: {w.manager_name || '—'}</p>
            <span className={`chip status-${w.is_active ? 'active' : 'cancelled'}`}>{w.is_active ? 'active' : 'inactive'}</span>
          </div>
        ))}
        {items.length === 0 && <div className="muted">No warehouses yet.</div>}
      </div>
    </section>
  );
}
